import React from 'react';
import { injectIntl } from 'react-intl';
import { messages } from "../common/Translations";
import { Field } from 'redux-form';
import TriggerPortalContactsModal from '../portal-contact/TriggerableModal';
import classNames from 'classnames';

const KeywordsCountSelect = props => {

    let {
        isAdmin,
        maxKeywordsCount,
        keywords,
        keywordsCount,
        intl: { formatMessage: t }
    } = props;

    const {
        inputLimiterKeywordsModalTitle: title,
        inputLimiterButtonText: btnText,
        inputLimiterKeywordsModalBodyLine1: body1,
        inputLimiterKeywordsModalBodyLine2: body2,
        keywordsNumber
    } = messages;

    const modalProps = {
        departmentFilter: department => department.isSupportingKeywords,
        title: t(title),
        body: (
            <div>
                <p>{t(body1)}</p>
                <p>{t(body2)}</p>
            </div>
        )
    };

    if (!isAdmin && maxKeywordsCount && maxKeywordsCount <= keywords.length) {
        return (
            <div className="form-group row">
                <div className="col-sm-10 offset-sm-2">
                    <TriggerPortalContactsModal {...modalProps} >
                        {
                            showModal => {
                                return (
                                    <button
                                        role={'button'}
                                        className={classNames('btn', 'btn-info')}
                                        onClick={showModal}
                                    >
                                        {t(btnText)}
                                    </button>
                                );
                            }
                        }
                    </ TriggerPortalContactsModal>
                </div>
            </div>
        );
    }

    const getFieldProps = showModal => {
        if (isAdmin) {
            return {
                component: "select",
                className: classNames(["form-control"]),
                children: keywordsCount.map((item) => {
                    return <option key={item.value} value={item.value}>{item.label}</option>
                })
            }
        } else {
            return {
                component: 'input',
                type: "text",
                className: classNames(["form-control", "disabled", "clickable"]),
                onClick: showModal,
                value: maxKeywordsCount,
            };
        }
    };

    return (
        <div className="form-group row">
            <label className="col-sm-2 col-form-label">
                <b>{t(keywordsNumber)}</b>
            </label>
            <div className="col-sm-10">
                <TriggerPortalContactsModal {...modalProps} >
                    {
                        showModal => (
                            <Field
                                name="keywordsCount"
                                {...getFieldProps(showModal)}
                            />
                        )
                    }
                </ TriggerPortalContactsModal>
            </div>
        </div>
    );

};

export default injectIntl(KeywordsCountSelect);


// WEBPACK FOOTER //
// ./web/src/components/company/KeywordsCountSelect.jsx